import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { questionType } from '../../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../../common";
import { authTokenSelector } from '../../../session';
import { currentAttemptSelector, questionsSelector } from '../../selectors';
import getAttemptConfiguration from '../attempts/get';
import { ANSWERS_API_ENDPOINT } from '../endpoints';
import { updateResourceState } from '../util';

const actions = createActions({
  QUESTION_ATTEMPTS: {
    SUBMIT_ANSWER: (questionId, answer) => ({ questionId, answer }),
    API: {
      SUBMIT_ANSWER: apiResourceActionCreator('submittedAnswer')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(ANSWERS_API_ENDPOINT, authToken, payload, actions.questionAttempts.api.submitAnswer)

export function* submitAnswer(action) {
  const { questionId, answer } = action.payload;
  const authToken = yield select(authTokenSelector);

  const currentAttempt = yield select(currentAttemptSelector);

  const questions = yield select(questionsSelector);
  const question = fp.find((question) => question.id === questionId)(questions);
  const isMultiChoice = question.questionType === questionType.MultiChoice;

  yield put(apiAction(authToken, ({
    questionAttempt: {
      quizAttemptId: currentAttempt.quizAttempt.id,
      questionId,
      answerText: isMultiChoice ? null : answer
    },
    selectedAnswers: isMultiChoice ? answer : []
  })));

  const { success: submittedAnswer } = yield apiActionResult(actions.questionAttempts.api.submitAnswer);

  if (submittedAnswer) {
    yield put(getAttemptConfiguration.action.attempts.get(currentAttempt.quizAttempt.contentId));
  }
}

const configuration = {
  name: 'submitAnswer',
  action: actions,
  sagas: submitAnswer,
  reducers: {
    request: (state, action) => updateResourceState(state, 'submittedAnswer', ({
      isFetching: true
    })),
    success: (state, action) => updateResourceState(state, 'submittedAnswer', ({
      isFetching: false,
      result: action.payload.submittedAnswer,
      error: null
    })),
    failed: (state, action) => updateResourceState(state, 'submittedAnswer', ({
      isFetching: false,
      error: action.payload.error
    })),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/questionAttempts/submitAnswer.js